export default "__VITE_ASSET__cDYgrn0V__"